import {
  isAsyncThunkAction,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import { loginWithGoogle, loginWithEmail, logout, setUser } from "./authSlice";

const changesSession = isAsyncThunkAction(
  loginWithGoogle,
  loginWithEmail,
  logout,
);

export const createSessionMiddleware =
  () =>
  ({ getState }) => {
    const pending = new Map();
    return (next) => (action) => {
      const uid = getState().auth.user?.uid;
      if (
        (setUser.match(action) && uid !== action.payload?.uid) ||
        logout.fulfilled.match(action)
      ) {
        pending.clear();
      }
      // Sign-in and sign-out complete across the identity change they initiate.
      if (changesSession(action)) return next(action);
      if (isPending(action)) {
        pending.set(action.meta.requestId, uid);
      } else if (isFulfilled(action) || isRejected(action)) {
        const requestId = action.meta.requestId;
        const current =
          Boolean(uid) &&
          pending.has(requestId) &&
          pending.get(requestId) === uid;
        pending.delete(requestId);
        if (!current) return action;
      }
      return next(action);
    };
  };
